
import './Game.scss';
import store, { RootState } from "../store";
import { gameActions } from './gameSlice';
import { useAppSelector } from '../redux';
import BattleScreen from './BattleScreen';
import StartScreen from '../StartScreen/StartScreen';
import { GamePlayState } from '../Enums/GameEnums'
import { GameOverScreen } from '../GameOver/GameOverScreen'
import { RewardScreen } from '../Reward/RewardScreen'
import CharacterSelectionScreen from '../StartScreen/CharacterSelectionScreen';
import Story from '../StartScreen/Story';
import MusicAsset from "../Components/MusicAsset";
import { useEffect } from 'react';
import Scoreboard from '../Scoreboard/Scoreboard';
import Help from '../Help/Help';

function Game() {
  const gameState = useAppSelector((state: RootState) => state.game)

  useEffect(() => {

    const keyDownHandler = e => {
      if (e.key === 'Enter' || e.keyCode === 13 ||
          e.key === "Escape" || e.keyCode === 27
      ) {
        e.preventDefault();

        store.dispatch(gameActions.closePopup());
        store.dispatch(gameActions.hideScoreboard());
        store.dispatch(gameActions.hideHelp());
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, []);


  function ScreenHandler() {

    if (gameState.isScoreboardVisible) {
      return <Scoreboard />
    }

    if (gameState.isHelpVisible) {
      return <Help />
    }

    switch (gameState.gamePlayState) {
      case GamePlayState.GAME_START:
        return <StartScreen />
      case GamePlayState.DEFEAT:
        return < GameOverScreen />
      case GamePlayState.VICTORY:
        return < RewardScreen />
      case GamePlayState.STORY_OUTRO:
      case GamePlayState.STORY_INTRO:
        return < Story />
      case GamePlayState.CHARACTER_SELECTION:
        return < CharacterSelectionScreen />
      case GamePlayState.BETTING:
      case GamePlayState.PLAYER_CARD_REVEAL:
      case GamePlayState.PLAYER_ACTION:
      case GamePlayState.DEALER_CARD_REVEAL:
        return < BattleScreen />
    }

  }

  return (
    <div className="game">
      {gameState.gamePlayState === GamePlayState.GAME_START && <MusicAsset name="BlackjackRPG_Title Music No Loop_20.10.2023.mp3" loop={true}/>}
      {gameState.gamePlayState === GamePlayState.DEFEAT && <MusicAsset name="BlackjackRPG_Somber Music_20.10.2023.mp3" loop={true}/>}
      {gameState.gamePlayState === GamePlayState.VICTORY && <MusicAsset name="BlackjackRPG_Victory Fanfare_20.10.2023.mp3"/>}
      {(gameState.gamePlayState === GamePlayState.STORY_INTRO
          || gameState.gamePlayState === GamePlayState.CHARACTER_SELECTION
          || gameState.gamePlayState === GamePlayState.STORY_OUTRO) &&
        <MusicAsset name="BlackjackRPG_Storytelling Music_20.10.2023.mp3" loop={true} />
      }
      {gameState.gamePlayState === GamePlayState.BETTING && <MusicAsset name="BlackjackRPG_Lobby Music_20.10.2023.mp3" loop={true} />}
      {(gameState.gamePlayState === GamePlayState.PLAYER_CARD_REVEAL
          || gameState.gamePlayState === GamePlayState.PLAYER_ACTION
          || gameState.gamePlayState === GamePlayState.DEALER_CARD_REVEAL) &&
          <MusicAsset name="BlackjackRPG_Combat Music_20.10.2023.mp3" loop={true} />
      }
      {ScreenHandler()}
    </div>
  );
}

export default Game;
